import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { DropdownButton } from 'react-bootstrap';
import { Dropdown } from 'react-bootstrap';

export class NotPickedReason extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                {
                    (this.props.showBackorder || this.props.canCancel)
                        ?
                        <DropdownButton id="dropdown-basic-button" title={this.props.pickLater ? "Pick Later" : "Not Found"}>
                        {
                            !this.props.pickLater
                                &&
                                <div>
                                    <Dropdown.Item onClick={() => this.props.doNotPick(this.props.lineId, 'pick-later')}>Pick Later</Dropdown.Item>
                                    <Dropdown.Divider />
                                </div>
                        } 
                        {
                            this.props.showBackorder
                            &&
                            <div>
                                    <Dropdown.Item onClick={() => this.props.backorderItem(this.props.lineId, 'backorder')}>Backorder</Dropdown.Item>
                                    <Dropdown.Divider />
                            </div>
                        }
                        {
                            this.props.canCancel &&
                            <div>
                                <Dropdown.Item onClick={() => this.props.cancelItem(this.props.lineId, 'cancel')}>Cancel Item</Dropdown.Item>
                            </div>
                        }
                    </DropdownButton>
                    :
                    <Button onClick={() => this.props.doNotPick(this.props.lineId, 'pick-later')}>Pick Later</Button>
                } 
            </div>
        );
    }
}
